import { BackdropLoader, Icon, ExpandedTooltip } from '@livable/saas-react-components';
import { Button, Table, TableBody, TableCell, TableContainer, TableRow, Chip, Typography, IconButton } from '@mui/material';
import { observer } from 'mobx-react-lite';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { BasicTooltip } from '@livable/saas-react-components';
import TransactionMenu from 'src/components/transactions/TransactionMenu';
import { useStore } from 'src/stores';
import MonthSummary from '../MonthSummary';
import useStyles from './styles';
import {
// PAYMENT_METHOD_TYPE,
TRANSACTION_STATUSES_NAMES } from 'src/constants/payments';
import moment from 'moment/moment';
import { getSubmeterMeterLine } from 'src/utils/submeterStatement';

// The cells a transaction row renders: time, type, service, one period cell, notes and amount always; the
// informational cell only on informational rows; the menu cell unless the company is AppFolio.
const getCellCount = (transaction, isAppfolio) => 6 + (transaction !== null && transaction !== void 0 && transaction.isInformational ? 1 : 0) + (isAppfolio ? 0 : 1);
export const TransactionsTable = observer(_ref => {
  var _data$transactions;
  let _ref$data = _ref.data,
    data = _ref$data === void 0 ? {} : _ref$data,
    triggerRefresh = _ref.triggerRefresh,
    setTriggerRefresh = _ref.setTriggerRefresh;
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const store = useStore();
  return /*#__PURE__*/React.createElement("div", {
    className: classes.transactionsTable
  }, /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: store.payment.getResidentAccountTransactionHistoryV2Async.inProgress || store.utilityProviders.getUtilityInfoAsync.inProgress || store.utilityProviders.getPropertyUtilityInfoAsync.inProgress
  }), /*#__PURE__*/React.createElement(MonthSummary, {
    data: data.summary
  }), /*#__PURE__*/React.createElement(TableContainer, null, /*#__PURE__*/React.createElement(Table, {
    "aria-label": "transactions table",
    type: "compactMobile"
  }, /*#__PURE__*/React.createElement(TableBody, null, (_data$transactions = data.transactions) === null || _data$transactions === void 0 ? void 0 : _data$transactions.map((transaction, index) => {
    var _transaction$submeter, _transaction$metadata, _transaction$metadata2, _transaction$metadata3, _transaction$period, _transaction$metadata4, _transaction$metadata5, _transaction$metadata6, _transaction$metadata7, _transaction$metadata8, _transaction$metadata9, _transaction$metadata0, _transaction$metadata1, _transaction$metadata10, _transaction$metadata11, _transaction$metadata12, _transaction$metadata13, _transaction$metadata14, _transaction$submeter2;
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: (transaction === null || transaction === void 0 ? void 0 : transaction.time) + index
    }, /*#__PURE__*/React.createElement(TableRow, {
      className: (transaction === null || transaction === void 0 || (_transaction$submeter = transaction.submeterMeters) === null || _transaction$submeter === void 0 ? void 0 : _transaction$submeter.length) > 0 ? classes.chargeWithMeters : undefined
    }, /*#__PURE__*/React.createElement(TableCell, {
      className: classes.mediumCell
    }, /*#__PURE__*/React.createElement("span", {
      className: classes.transactionTime
    }, transaction === null || transaction === void 0 ? void 0 : transaction.time)), /*#__PURE__*/React.createElement(TableCell, {
      className: classes.mediumCell
    }, transaction === null || transaction === void 0 ? void 0 : transaction.type, /*#__PURE__*/React.createElement("span", {
      className: classes.showTablet
    }, ": ", transaction === null || transaction === void 0 ? void 0 : transaction.service)), (transaction === null || transaction === void 0 ? void 0 : transaction.isInformational) && /*#__PURE__*/React.createElement(TableCell, {
      className: classes.flex
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body1"
    }, t('general.informational_transaction')), /*#__PURE__*/React.createElement(ExpandedTooltip, {
      type: "grey",
      title: t('general.balance_transferred_to_pms_ledger'),
      placement: "top"
    }, /*#__PURE__*/React.createElement(IconButton, null, /*#__PURE__*/React.createElement(Icon, {
      type: "info",
      state: "info"
    })))), /*#__PURE__*/React.createElement(TableCell, {
      className: "".concat(classes.hideTablet, " ").concat(classes.smallCell)
    }, (transaction === null || transaction === void 0 ? void 0 : transaction.service) || (transaction === null || transaction === void 0 || (_transaction$metadata = transaction.metadata) === null || _transaction$metadata === void 0 ? void 0 : _transaction$metadata.title)), !((_transaction$metadata2 = transaction.metadata) !== null && _transaction$metadata2 !== void 0 && _transaction$metadata2.paperStatementYear && (_transaction$metadata3 = transaction.metadata) !== null && _transaction$metadata3 !== void 0 && _transaction$metadata3.paperStatementMonth) && /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(BasicTooltip, {
      title: (transaction === null || transaction === void 0 || (_transaction$period = transaction.period) === null || _transaction$period === void 0 ? void 0 : _transaction$period.length) > 40 ? transaction === null || transaction === void 0 ? void 0 : transaction.period : '',
      placement: "top-start"
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.periodCell
    }, transaction === null || transaction === void 0 ? void 0 : transaction.period))), ((_transaction$metadata4 = transaction.metadata) === null || _transaction$metadata4 === void 0 ? void 0 : _transaction$metadata4.paperStatementYear) && ((_transaction$metadata5 = transaction.metadata) === null || _transaction$metadata5 === void 0 ? void 0 : _transaction$metadata5.paperStatementMonth) && /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(BasicTooltip, {
      title: moment("".concat(transaction.metadata.paperStatementYear, "-").concat(transaction.metadata.paperStatementMonth)).format('MMMM YYYY'),
      placement: "top-start"
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.periodCell
    }, t('resident_account.statement_period'), ' ', moment("".concat(transaction.metadata.paperStatementYear, "-").concat(transaction.metadata.paperStatementMonth)).format('MMMM YYYY')))), /*#__PURE__*/React.createElement(TableCell, {
      align: "right",
      className: classes.notesCell
    }, (transaction === null || transaction === void 0 || (_transaction$metadata6 = transaction.metadata) === null || _transaction$metadata6 === void 0 ? void 0 : _transaction$metadata6.memo) && /*#__PURE__*/React.createElement(BasicTooltip, {
      title: "Memo: ".concat(transaction === null || transaction === void 0 || (_transaction$metadata7 = transaction.metadata) === null || _transaction$metadata7 === void 0 ? void 0 : _transaction$metadata7.memo),
      placement: "top"
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "actionIcon",
      size: "small",
      'custom-attribute': '413-Transactions-transaction-table'
    }, /*#__PURE__*/React.createElement(Icon, {
      type: "memo"
    }))), (transaction === null || transaction === void 0 || (_transaction$metadata8 = transaction.metadata) === null || _transaction$metadata8 === void 0 ? void 0 : _transaction$metadata8.status) === TRANSACTION_STATUSES_NAMES.InProgress && /*#__PURE__*/React.createElement("div", {
      className: classes.chipContainer
    }, /*#__PURE__*/React.createElement(Chip, {
      label: t('general.pending_chip'),
      variant: "warning"
    }), (transaction === null || transaction === void 0 || (_transaction$metadata9 = transaction.metadata) === null || _transaction$metadata9 === void 0 || (_transaction$metadata9 = _transaction$metadata9.verificationUrl) === null || _transaction$metadata9 === void 0 ? void 0 : _transaction$metadata9.length) && /*#__PURE__*/React.createElement(Typography, {
      variant: "body1"
    }, t('general.verification_needed'))), (transaction === null || transaction === void 0 || (_transaction$metadata0 = transaction.metadata) === null || _transaction$metadata0 === void 0 ? void 0 : _transaction$metadata0.status) === TRANSACTION_STATUSES_NAMES.Failed && /*#__PURE__*/React.createElement("div", {
      className: classes.chipContainer
    }, /*#__PURE__*/React.createElement(Chip, {
      label: t('general.failed_chip'),
      variant: "critical"
    })), (transaction === null || transaction === void 0 || (_transaction$metadata1 = transaction.metadata) === null || _transaction$metadata1 === void 0 ? void 0 : _transaction$metadata1.notes) && /*#__PURE__*/React.createElement(BasicTooltip, {
      title: "Note: ".concat(transaction === null || transaction === void 0 || (_transaction$metadata10 = transaction.metadata) === null || _transaction$metadata10 === void 0 ? void 0 : _transaction$metadata10.notes),
      placement: "top"
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "actionIcon",
      size: "small",
      'custom-attribute': '414-Transactions-transaction-table'
    }, /*#__PURE__*/React.createElement(Icon, {
      type: "note"
    })))), /*#__PURE__*/React.createElement(TableCell, {
      align: "right",
      className: classes.summaryCell
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.flexWrapper
    }, transaction !== null && transaction !== void 0 && (_transaction$metadata11 = transaction.metadata) !== null && _transaction$metadata11 !== void 0 && _transaction$metadata11.amountBeforeUtilityCap ? /*#__PURE__*/React.createElement("div", {
      className: classes.utilityCap
    }, /*#__PURE__*/React.createElement("s", null, "$", transaction === null || transaction === void 0 || (_transaction$metadata12 = transaction.metadata) === null || _transaction$metadata12 === void 0 ? void 0 : _transaction$metadata12.amountBeforeUtilityCap), /*#__PURE__*/React.createElement(ExpandedTooltip, {
      title: "Utility cap is applied",
      placement: "top",
      type: "info"
    }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Icon, {
      type: "question",
      state: "info"
    })))) : '', ![TRANSACTION_STATUSES_NAMES.Failed, TRANSACTION_STATUSES_NAMES.InProgress].includes(transaction === null || transaction === void 0 || (_transaction$metadata13 = transaction.metadata) === null || _transaction$metadata13 === void 0 ? void 0 : _transaction$metadata13.status) && (transaction === null || transaction === void 0 ? void 0 : transaction.isCharge) && /*#__PURE__*/React.createElement(Icon, {
      state: "dark",
      type: "plus"
    }), ![TRANSACTION_STATUSES_NAMES.Failed, TRANSACTION_STATUSES_NAMES.InProgress].includes(transaction === null || transaction === void 0 || (_transaction$metadata14 = transaction.metadata) === null || _transaction$metadata14 === void 0 ? void 0 : _transaction$metadata14.status) && (transaction === null || transaction === void 0 ? void 0 : transaction.isCredit) && /*#__PURE__*/React.createElement(Icon, {
      state: "dark",
      type: "minus"
    }), /*#__PURE__*/React.createElement("div", {
      className: classes.transactionAmount
    }, transaction === null || transaction === void 0 ? void 0 : transaction.amount))), !store.company.companyFeatureStore.isAppfolio && /*#__PURE__*/React.createElement(TableCell, {
      align: "right",
      className: classes.xsmallCell
    }, /*#__PURE__*/React.createElement(TransactionMenu, {
      id: transaction === null || transaction === void 0 ? void 0 : transaction.id,
      transaction: transaction
      // transactionType={transaction?.transactionType}
      // type={transaction?.type}
      // transactionStatus={transaction?.metadata?.status}
      ,
      triggerRefresh: triggerRefresh,
      setTriggerRefresh: setTriggerRefresh
    }))), (transaction === null || transaction === void 0 || (_transaction$submeter2 = transaction.submeterMeters) === null || _transaction$submeter2 === void 0 ? void 0 : _transaction$submeter2.length) > 0 && /*#__PURE__*/React.createElement(TableRow, {
      className: classes.meterRow
    }, /*#__PURE__*/React.createElement(TableCell, {
      colSpan: getCellCount(transaction, store.company.companyFeatureStore.isAppfolio),
      className: classes.meterLinesCell
    }, transaction.submeterMeters.map((meter, meterIndex) => /*#__PURE__*/React.createElement(Typography, {
      key: "".concat(transaction.id, "-meter-").concat(meterIndex),
      color: "light",
      variant: "h6"
    }, getSubmeterMeterLine(meter, transaction))))));
  })))));
});
TransactionsTable.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.number,
    summary: PropTypes.shape({
      month: PropTypes.string,
      isMoveInMonth: PropTypes.bool,
      isSummary: PropTypes.bool,
      balanceOnFirst: PropTypes.string,
      monthlyCharges: PropTypes.string,
      paymentsAndCredits: PropTypes.string,
      currentBalance: PropTypes.string,
      startingBalance: PropTypes.string
    }),
    transactions: PropTypes.arrayOf(PropTypes.shape({
      time: PropTypes.string,
      type: PropTypes.string,
      service: PropTypes.string,
      period: PropTypes.string,
      isCharge: PropTypes.bool,
      isCredit: PropTypes.bool,
      amount: PropTypes.string
    }))
  })
};